// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var DateFns = require("date-fns");
var Icon__Jsx3 = require("../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var CalendarDate = require("../../reason/common/types/CalendarDate.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var Theme__Color = require("../../reason/common/Theme/Theme__Color.bs.js");
var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");
var FragmentErrorBoundary = require("../common/ErrorHandling/FragmentErrorBoundary.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
var PropertyPageForSalePropertySidecardMlsInfo_mlsPlan_graphql = require("../../__generated__/PropertyPageForSalePropertySidecardMlsInfo_mlsPlan_graphql.bs.js");
var PropertyPageForSalePropertySidecardMlsInfo_property_graphql = require("../../__generated__/PropertyPageForSalePropertySidecardMlsInfo_property_graphql.bs.js");

var convertFragment = PropertyPageForSalePropertySidecardMlsInfo_mlsPlan_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyPageForSalePropertySidecardMlsInfo_mlsPlan_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyPageForSalePropertySidecardMlsInfo_mlsPlan_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyPageForSalePropertySidecardMlsInfo_mlsPlan_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyPageForSalePropertySidecardMlsInfo_mlsPlan_graphql.node, convertFragment, fRef);
}

var Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyPage__ForSalePropertySidecard__MlsInfo$FromMlsPlan(props) {
  var mlsPlan = use(props.mlsPlan);
  var match;
  switch (mlsPlan.__typename) {
    case "ListOnMlsAsActive" :
        match = [
          Caml_option.some(mlsPlan.onMlsAt),
          mlsPlan.willShowPriorToMls,
          mlsPlan.willAcceptOffersPriorToMls
        ];
        break;
    case "ListOnMlsAsComingSoon" :
        match = [
          Caml_option.some(mlsPlan.activeOnMlsOn),
          mlsPlan.willShowPriorToMls,
          mlsPlan.willAcceptOffersPriorToMls
        ];
        break;
    case "NoMlsPlan" :
        match = [
          undefined,
          mlsPlan.willShow,
          mlsPlan.willAcceptOffers
        ];
        break;
    case "__unselected" :
        match = UnselectedUnionMemberError.raise("Unselected PropertyForEditingResult " + mlsPlan._0);
        break;
    
  }
  var onMlsAt = match[0];
  var items = [
    match[1] ? "Will show before MLS" : "Won't show before MLS",
    match[2] ? "Will accept offers before MLS" : "Won't accept offers before MLS"
  ];
  return JsxRuntime.jsxs("div", {
              children: [
                onMlsAt !== undefined ? JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                                children: "Expected on MLS",
                                className: "text-gray-500 uppercase font-medium tracking-wide"
                              }),
                          JsxRuntime.jsx("div", {
                                children: DateFns.format(CalendarDate.toLocalDate(Caml_option.valFromOption(onMlsAt)), "MMM d, YYY"),
                                className: "text-lg font-medium"
                              })
                        ],
                        className: "space-y-2"
                      }) : null,
                JsxRuntime.jsx("ul", {
                      children: items.map(function (item, index) {
                            return JsxRuntime.jsxs("li", {
                                        children: [
                                          JsxRuntime.jsx("div", {
                                                children: JsxRuntime.jsx(Icon__Jsx3.make, {
                                                      icon: "Bullet",
                                                      color: Theme__Color.silver
                                                    }),
                                                className: "-mb-2 mr-2"
                                              }),
                                          item
                                        ],
                                        className: "flex flex-row space-x-2 font-medium"
                                      }, index.toString());
                          }),
                      className: "mt-2 space-y-3"
                    })
              ],
              className: TailwindMerge.twMerge([
                    "space-y-4",
                    Core__Option.getOr(props.className, "")
                  ])
            });
}

var FromMlsPlan = {
  Fragment: Fragment,
  make: PropertyPage__ForSalePropertySidecard__MlsInfo$FromMlsPlan
};

var convertFragment$1 = PropertyPageForSalePropertySidecardMlsInfo_property_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyPageForSalePropertySidecardMlsInfo_property_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyPageForSalePropertySidecardMlsInfo_property_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyPageForSalePropertySidecardMlsInfo_property_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyPageForSalePropertySidecardMlsInfo_property_graphql.node, convertFragment$1, fRef);
}

var Fragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function PropertyPage__ForSalePropertySidecard__MlsInfo$WithoutErrorBoundary(props) {
  var match = use$1(props.property);
  return JsxRuntime.jsx(PropertyPage__ForSalePropertySidecard__MlsInfo$FromMlsPlan, {
              mlsPlan: match.mlsPlan.fragmentRefs,
              className: props.className
            });
}

var WithoutErrorBoundary = {
  Fragment: Fragment$1,
  make: PropertyPage__ForSalePropertySidecard__MlsInfo$WithoutErrorBoundary
};

function PropertyPage__ForSalePropertySidecard__MlsInfo(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
              fragmentDisplayName: "property MLS info",
              children: JsxRuntime.jsx(PropertyPage__ForSalePropertySidecard__MlsInfo$WithoutErrorBoundary, {
                    property: props.property,
                    className: props.className
                  })
            });
}

var make = PropertyPage__ForSalePropertySidecard__MlsInfo;

exports.FromMlsPlan = FromMlsPlan;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* date-fns Not a pure module */
